/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */
import type { MutationFunction, QueryFunction, QueryKey, UseMutationOptions, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { Enterprise, ProblemDetails, PutEnterpriseParams } from '../../model';
import type { ErrorType } from '../../utils/UseCustomInstance';
import { useCustomInstance } from '../../utils/UseCustomInstance';

export const useGetEnterpriseHook = () => {
    const getEnterprise = useCustomInstance<Enterprise>();

    return (signal?: AbortSignal) => {
        return getEnterprise({ url: `/GetEnterprise`, method: 'get', signal });
    };
};

export const getGetEnterpriseQueryKey = () => [`/GetEnterprise`] as const;

export const useGetEnterpriseQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEnterpriseHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEnterpriseQueryKey();

    const getEnterprise = useGetEnterpriseHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseHook>>>> = ({ signal }) => getEnterprise(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetEnterpriseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseHook>>>>;
export type GetEnterpriseQueryError = ErrorType<ProblemDetails>;

export const useGetEnterprise = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEnterpriseHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetEnterpriseQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetEnterpriseListHook = () => {
    const getEnterpriseList = useCustomInstance<Enterprise>();

    return (signal?: AbortSignal) => {
        return getEnterpriseList({ url: `/GetEnterpriseList`, method: 'get', signal });
    };
};

export const getGetEnterpriseListQueryKey = () => [`/GetEnterpriseList`] as const;

export const useGetEnterpriseListQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEnterpriseListHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseListHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseListHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEnterpriseListQueryKey();

    const getEnterpriseList = useGetEnterpriseListHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseListHook>>>> = ({ signal }) =>
        getEnterpriseList(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetEnterpriseListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseListHook>>>>;
export type GetEnterpriseListQueryError = ErrorType<ProblemDetails>;

export const useGetEnterpriseList = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEnterpriseListHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEnterpriseListHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetEnterpriseListQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePutEnterpriseHook = () => {
    const putEnterprise = useCustomInstance<Enterprise>();

    return (params?: PutEnterpriseParams) => {
        return putEnterprise({ url: `/PutEnterprise`, method: 'put', params });
    };
};

export const usePutEnterpriseMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutEnterpriseHook>>>,
        TError,
        { params?: PutEnterpriseParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutEnterpriseHook>>>,
    TError,
    { params?: PutEnterpriseParams },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putEnterprise = usePutEnterpriseHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutEnterpriseHook>>>, { params?: PutEnterpriseParams }> = (
        props
    ) => {
        const { params } = props ?? {};

        return putEnterprise(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutEnterpriseMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutEnterpriseHook>>>>;

export type PutEnterpriseMutationError = ErrorType<ProblemDetails>;

export const usePutEnterprise = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutEnterpriseHook>>>,
        TError,
        { params?: PutEnterpriseParams },
        TContext
    >;
}) => {
    const mutationOptions = usePutEnterpriseMutationOptions(options);

    return useMutation(mutationOptions);
};
